import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

// import modules
import user from './modules/user'
import progress from './modules/progress'

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  reducer: state => ({ progress: state.progress }),
  storage: window.localStorage // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    progress
  },
  plugins: [vuexLocalStorage.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js